import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Component } from 'react';
import { Field } from 'redux-form';
// import { Field } from 'react-final-form';
import { getCustomStyles, mapValidation } from '@defi/core-utils';
import { withStyles } from '@material-ui/core/styles';
import InputMasked from './InputMasked';
const styles = {
  truncate: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  hide: {
    display: 'none'
  },
  default: {
    height: 'auto',
    width: '100%',
    '& input': {
      // padding: '3px',
      // color: '#000',
      // fontSize: '14px',
      // height: 14
      backgroundColor: "transparent !important"
    },
    '& textarea': {
      padding: '3px',
      color: '#000',
      fontSize: 12,
      margin: '0 0 -7px 0',
      paddingTop: 1
    },
    '& p': {
      color: 'red',
      margin: '2px 0'
    }
  },
  edit: {
    '& input, & textarea': {
      // borderBottom: '2px solid #ccc',
      // backgroundColor: '#fff',
      //  marginTop: '4px'
    }
  },
  disabled: {
    '& textarea': {
      padding: '3px 4px 4px 4px'
    }
  },
  error: {
    '& input': {
      border: '1px solid red',
      marginTop: 5
    }
  },
  floatingText: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '12px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 1
  }
};
class TextInput extends Component {
  constructor() {
    super(...arguments);
    this.reachedMax = this.props.children.get('Value').length === this.props.children.getIn(['DataElement', 'FieldLength']);
    this.handleOnKeyUp = e => {
      if (e.target.value.length === this.props.fieldLength) {
        if (e.key !== 'Tab') {
          if (this.reachedMax) {
            this.props.toggleSnackbar(true, 'You have reached the maximum length of this input field', 'red');
          } else {
            this.reachedMax = true;
          }
        }
      } else {
        this.reachedMax = false;
      }
    };
    this.renderTextField = _ref => {
      let input = _ref.input,
        label = _ref.label,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        custom = _objectWithoutProperties(_ref, ["input", "label", "meta"]);
      return /*#__PURE__*/React.createElement(InputMasked, Object.assign({
        id: String(this.props.children.get('ElementId')),
        maxLength: this.props.children.getIn(['DataElement', 'FieldLength']),
        mask: this.props.mask,
        disabled: false,
        multiline: this.props.children.get('IsExpandable'),
        className: "".concat(this.getClasses(), " ").concat(touched && error ? this.props.classes.errorText : '', " ").concat(this.props.disabled ? this.props.classes.hide : '')
        // floatingLabelText={this.props.name}
        ,
        name: this.props.name,
        helperText: touched && error
      }, input, custom));
    };
  }
  UNSAFE_componentWillMount() {
    this.handleChangeRequirement(this.props.children.get('Value'));
  }
  componentDidUpdate() {
    if (this.props.editStatus && this.props.validation.length > 0) {
      if (!this.props.open) {
        this.props.toggleSection(true);
      }
    }
  }
  getClasses() {
    const _this$props = this.props,
      classes = _this$props.classes,
      editStatus = _this$props.editStatus;
    const statusClass = editStatus ? classes.edit : classes.disabled;
    return "".concat(classes.default, " ").concat(statusClass);
  }
  handleChangeRequirement(value) {
    this.props.changeRequirement(value);
  }
  render() {
    // const customStyles = getCustomStyles(this.props.format);
    const _this$props2 = this.props,
      children = _this$props2.children,
      classes = _this$props2.classes,
      name = _this$props2.name,
      context = _this$props2.context,
      fieldName = _this$props2.fieldName;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      title: name,
      className: classes.floatingText
    }, name), /*#__PURE__*/React.createElement(Field, {
      context: context,
      id: String(children.get('ElementId')),
      name: fieldName,
      component: this.renderTextField,
      onKeyUp: this.handleOnKeydUp,
      validate: this.props.valiation,
      onBlur: e => this.handleChangeRequirement(e.target.value)
    }));
  }
}
export default withStyles(styles)(TextInput);